<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="章节名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <!-- <a-select
              v-decorator="[
              'name',
              {rules: [{ required: true, message: '请选择章节名称!' }],initialValue:info.name}
            ]"
            >
              <a-select-option
                v-for="(item,index) in typelist"
                :key="index"
                :value="item.name"
              >{{item.name}}</a-select-option>
            </a-select> -->
            <a-input
              placeholder="请输入章节名称"
              v-decorator="[
          'title',
          {rules: [{ required: false, message: '请输入章节名称!' }],initialValue:info.title}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;

export default {
  props: {
    id: String,
    zjId: Number
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {},
      isloading: false,
      loadingTip: "加载中...",
      typelist: [
        {
          name: "第一章 朱元璋篇",
          id: 1
        },
        {
          name: "第二章",
          id: 2
        },
        {
          name: "第三章",
          id: 3
        }
      ]
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function() {
      that = this;
      console.log(typeof this.id)
      console.log(this.zjId)
      if (this.zjId != 0) {
        //编辑
        this.getInfo();
      }
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    /**获取详情 */
    getInfo() {
      this.isloading = true;
      this.$api.course
        .getByChapterId(this.zjId)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            // console.log(res.data)
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.zjId) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.course
              .updateChapter(
                values.title,
                0,
                "",
                this.zjId
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //添加
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.course
              .saveChapter(
                values.title,
                this.id,
                0,
                ""
                // this.info.content ? this.info.content : "",
                // JSON.stringify(this.info.keywordsArr),
                // this.info.categoryId ? this.info.categoryId : "",
                // this.info.categoryName ? this.info.categoryName : "",
                // this.info.type,
                // this.info.type_name,
                // this.info.expert_id ? this.info.expert_id : "",
                // this.info.department_id ? this.info.department_id : "",
                // this.info.expert_name ? this.info.expert_name : "",
                // this.info.department_name ? this.info.department_name : "",
                // values.recommend
                //   ? this.$commen.changeBooleanInt(values.recommend)
                //   : this.$commen.changeBooleanInt(this.info.recommend)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
            // console.log(values.name);
            // this.$emit("callbackMethod",values.name);
          }
        }
      });
    },
    onChange() {
      //console.log(date, dateString);
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
</style>